import fetch from "../utils/fetch";
import env from "../env";

export function GetBySistemaId(sistemaId) {
    return fetch(env.apiUrl+`api/BlackList/GetBySistemaId/${sistemaId}`, {
        method: "GET",
        mode: "cors",
    })
      .then((res) => res.json())
      .catch(console.error);
}
